var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-area"},[_c('highcharts',{ref:"chart",staticClass:"hc",attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }